import invert from 'lodash/invert';

export const AdminPageIds = {
  ISSUE_TYPES: 'issueTypes',
  ISSUE_ATTRIBUTES: 'issueAttributes'
};

// Each id value should match the route path nested under "/admin/issue"
export const AdminPageTabIds = {
  ISSUES_PERMISSIONS: 'permissions',
  ISSUE_TYPES: 'types',
  ISSUE_ATTRIBUTES: 'attributes',
  ISSUE_ROOT_CAUSES: 'root-causes'
};

export const PermissionsResourceTypes = {
  ISSUES: 'quality_issues'
};

export const AdminPermissionLabels = {
  BASIC: 'basic',
  VIEW_ALL: 'viewAll',
  CREATE: 'create',
  VIEW_AND_CREATE: 'viewAndCreate',
  FULL_CONTROL: 'fullControl'
};

export const PermissionsLevelsToIds = {
  none: '0',
  view: '1',
  create: '2',
  edit: '3'
};

export const AdminPermissionsV2Actions = {
  READ: 'read',
  CREATE: 'create',
  WRITE: 'write'
};

export const AdminPermissionsV2Types = {
  VIEW_ALL: 'VIEW_ALL',
  VIEW_AND_CREATE: 'VIEW_AND_CREATE',
  CREATE: 'CREATE',
  FULL_CONTROL: 'FULL_CONTROL'
};

export const AdminPermissionsV2TypeToActions = {
  [AdminPermissionsV2Types.VIEW_ALL]: [AdminPermissionsV2Actions.READ],
  [AdminPermissionsV2Types.CREATE]: [AdminPermissionsV2Actions.CREATE],
  [AdminPermissionsV2Types.VIEW_AND_CREATE]: [AdminPermissionsV2Actions.READ, AdminPermissionsV2Actions.CREATE],
  [AdminPermissionsV2Types.FULL_CONTROL]: [
    AdminPermissionsV2Actions.READ,
    AdminPermissionsV2Actions.CREATE,
    AdminPermissionsV2Actions.WRITE
  ]
};

export const PermissionsV2TypeToValue = {
  [AdminPermissionsV2Actions.READ]: '1',
  [AdminPermissionsV2Actions.CREATE]: '2',
  [AdminPermissionsV2Actions.WRITE]: '3'
};

export const PermissionIdsToActions = invert(PermissionsV2TypeToValue);

export const PermissionsIdsToLevels = invert(PermissionsLevelsToIds);

export const NoPermissions = [{name: 'none'}];

export const NewAdminPermissionsArray = [
  {label: AdminPermissionLabels.VIEW_ALL, value: [0], id: '1', v2Value: AdminPermissionsV2Types.VIEW_ALL},
  {label: AdminPermissionLabels.CREATE, value: [1], id: '2', v2Value: AdminPermissionsV2Types.CREATE},
  {
    label: AdminPermissionLabels.VIEW_AND_CREATE,
    value: [0, 1],
    id: '12',
    v2Value: AdminPermissionsV2Types.VIEW_AND_CREATE
  },
  {
    label: AdminPermissionLabels.FULL_CONTROL,
    value: [0, 1, 2],
    id: '123',
    v2Value: AdminPermissionsV2Types.FULL_CONTROL
  }
];

export const AdminPermissionsArray = [
  {label: AdminPermissionLabels.BASIC, value: [], id: '0'},
  ...NewAdminPermissionsArray
];

export const AdminPermissionBulkOperations = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete'
};

export const AdminPermissionBulkOperationStatus = {
  SUCCESS: 'success',
  FAILED: 'failed'
};

export const BULK_CREATE_PERMISSION_COUNT_LIMIT_DEFAULT = 20;
